import { render, staticRenderFns } from "./vQuillEditor.vue?vue&type=template&id=2bd21994"
import script from "./vQuillEditor.vue?vue&type=script&lang=js"
export * from "./vQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./vQuillEditor.vue?vue&type=style&index=0&id=2bd21994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports